let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7g6eW")).then(() => parcelRequire('fXmH2'));